import ContactTile from '@gik/contact/components/ContactTile/ContactTile';
import { translationKeys } from '@gik/contact/i18n/en';
import { useBemCN } from '@gik/core/utils/bemBlock';
import { openIntercomWindow } from '@gik/core/utils/Intercom';
import { HTMLParser } from '@gik/ui/HTMLParser';
import React from 'react';
import { useTranslation } from 'react-i18next';

export default function Chat() {
  const bem = useBemCN('live-support');
  const { t } = useTranslation();

  function onButtonClicked() {
    openIntercomWindow();
  }

  return (
    <ContactTile
      {...bem()}
      title={t(translationKeys.LiveSupportTitle)}
      buttonText={t(translationKeys.LiveSupportButtonText)}
      buttonAction={onButtonClicked}
    >
      <>
        {/* TODO: we can use better translations by setting up the times as moment objects */}
        <HTMLParser rawHtml={t(translationKeys.LiveSupportTimes)} />
      </>
    </ContactTile>
  );
}
